export default "__VITE_ASSET__DI_iDqmJ__"